export default __webpack_public_path__ + "static/membership-aa6bb720a7d4b1356892c3ebb4f2d5bf.svg";